import { Tab, Tabs } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";
import { Table } from "stories";
import { currencyStyle } from "utils/customHooks/currencyFormat";
import { generateTitle } from "../../assetBreakdown/elements/Summery";

const headers = [
  {
    id: "title",
    title: "Sales Revenue",
  },
  {
    id: "price_psf",
    title: "Price PSF",
    align: "right",
  },
  {
    id: "total_price",
    title: "Total Market Value",
    align: "right",
  },
];
export const FinancialAnalysisTable = () => {
  const form = useFormContext();
  const [
    assets,
    parking,
    storage,
    saleTaxPercentage,
    totalRevenue,
    totalSalesTax,
    totalAssetValue,
  ] = useWatch({
    name: [
      "revenues.assets",
      "revenues.parking_assets",
      "revenues.storage_assets",
      "sale_tax_percentage",
      "total_revenue",
      "total_sale_tax",
      "total_asset_value",
    ],
    control: form.control,
  });
  let assetsArr = { ...assets };
  assetsArr = Object.keys(assetsArr).map((key) => ({
    uid: key,
    title: generateTitle(key),
    price_psf: `$ ${currencyStyle(assetsArr[key].price_psf)}`,
    total_price: `$ ${currencyStyle(assetsArr[key].total_price)}`,
    props: {
      title: {
        className: "capitalize",
      },
    },
  }));
  if (parking) {
    assetsArr.push({
      uid: "parking",
      title: "Parking",
      price_psf: `$ ${currencyStyle(parking.price_psf)}`,
      total_price: `$ ${currencyStyle(parking.total_price)}`,
    });
  }
  if (storage) {
    assetsArr.push({
      uid: "storage",
      title: "Storage",
      price_psf: `$ ${currencyStyle(storage.price_psf)}`,
      total_price: `$ ${currencyStyle(storage.total_price)}`,
    });
  }
  const assetsFooter = [
    {
      uid: "assets-footer",
      title: "Total Sales Revenue",
      price_psf: "",
      total_price: `$ ${currencyStyle(totalRevenue)}`,
    },
  ];

  const totalSalesTaxRows = [
    {
      uid: "total-sales-tax",
      title: "Total Sales Tax",
      price_psf: `${currencyStyle(
        Number((saleTaxPercentage || 0).toFixed(2))
      )}%`,
      total_price: `$ (${currencyStyle(
        Number(Math.abs(totalSalesTax).toFixed(2))
      )})`,
    },
  ];
  const totalSalesTaxFooter = [
    {
      uid: "total-sales-tax-footer",
      title: "Total Asset Value",
      price_psf: `$ ${currencyStyle(
        Number(totalAssetValue.price_psf.toFixed(2))
      )}`,
      total_price: `$ ${currencyStyle(totalAssetValue.total_price)}`,
    },
  ];

  return (
    <>
      <Tabs activeKey={"financial-analysis"}>
        <Tab
          eventKey={"financial-analysis"}
          title="Financial Analysis"
          tabClassName="capitalize text-left"
        >
          <Table
            sameColumnWidth
            headers={headers}
            rows={assetsArr}
            footer={assetsFooter}
          />
          <Table
            sameColumnWidth
            hideHeader
            headers={headers}
            rows={totalSalesTaxRows}
            footer={totalSalesTaxFooter}
          />
        </Tab>
      </Tabs>
    </>
  );
};
